import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M14 16a2 2 0 100-4 2 2 0 000 4zm7 0a2 2 0 100-4 2 2 0 000 4zM7 16a2 2 0 100-4 2 2 0 000 4z" fill="currentColor" /></svg>);